const UrlBase = {
  app_api: window.REACT_APP_API,
  app_url_localhost: window.REACT_BASE_LOCALHOST,
  app_api_get_order: window.REACT_APP_API_GET_ORDER,
  app_api_payment_prod: window.REACT_APP_API_PAYMENT_PROD
}

export default UrlBase
